export const InformationParagraph = ({ children }) => <p>{children}</p>;
